import PropTypes from 'prop-types';
import './Home.css';
import imageUrl1 from './../../assets/Container11.png';
import imageUrl2 from './../../assets/Container12.png';
import imageUrl3 from './../../assets/Container13.png';
import imageGreen from './../../assets/GreenImage.png';
import imagee from './../../assets/GJU group picture.jpg';
import imgbabaji from './../../assets/741.png';
import director from './../../assets/Prof. Khujan Singh.png';
import link1 from './../../assets/Detailed Brochure- Online Certificate Courses.pdf';
import link2 from './../../assets/Brief Brochure- Online Certificate Courses.pdf';
// import link4 from './../../assets/Nov_Notification.pdf';
import link3 from './../../assets/Revised Prospectus(CDOE).pdf'
import AdmissionJuly from './../../assets/Admission Brochure July 2025.pdf'
import Pjuly from './../../assets/Prospectus CDOE HKCL July 2025.pdf'
import link6 from './../../assets/Prospectus_CDOE_July_2025.pdf'


import React, { useState, useEffect } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import BaseUrl from '../../base-api';

const Home = () => {
  const items = [
    {
      src: imageUrl3,
      // altText: 'Slide 3',
      // caption: 'Slide 3',
      key: 5,
    },
    {
      src: imgbabaji,
      // altText: 'Slide 1',
      // caption: 'Slide 1',
      key: 1,
    },
    {
      src: imagee,
      // altText: 'Slide 1',
      // caption: 'Slide 1',
      key: 2,
    },
    {
      src: imageUrl2,
      // altText: 'Slide 1',
      // caption: 'Slide 1',
      key: 3,
    },
    {
      src: imageUrl1,
      // altText: 'Slide 2',
      // caption: 'Slide 2',
      key: 4,
    },
    
  ];
  // const [notices, setNotices] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item, index) => {
    let slideClass = '';
    if (index === activeIndex) {
      slideClass = 'active';
    } else if (index === (activeIndex === 0 ? items.length - 1 : activeIndex - 1)) {
      slideClass = 'carousel-item-prev';
    } else if (index === (activeIndex === items.length - 1 ? 0 : activeIndex + 1)) {
      slideClass = 'carousel-item-next';
    }
    return (
      <CarouselItem
        className={slideClass}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img src={item.src} alt={item.altText} width="100%" />
        <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
      </CarouselItem>
    );
  });
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 3000);
    return () => clearInterval(interval);
  }, [activeIndex, animating]);

  // useEffect(() => {
  //   axios
  //     .get(`${BaseUrl}/notification/home`)
  //     .then(function (response) {
  //       setNotices(response.data.notices);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // }, []);

  const download = (key) => {
    axios
      .get(`${BaseUrl}/notification/download?key=` + key)
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <>
      <div className='container mt-3 npm'>
        <Carousel
          style={{ width: "100%" }}
          activeIndex={activeIndex}
          next={next}
          slide={false}
          previous={previous}
          interval={2000} // 3-second interval
        // ride="carousel" // Enable automatic sliding
        >
          <CarouselIndicators
            items={items}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
          />
          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </Carousel>



        <Card className="my-2 mt-5 c1">
          <CardBody >
            <CardTitle className="text-center" tag="h5" style={{ color: 'green' }}><strong>
              Welcome to Skill Development Online Certificate Courses <br />
              where your journey to excellence begins! <br />
              Enroll today in your choice of course and unlock a world of
              limitless possibilities.</strong>
            </CardTitle>
            <br />
            <Row>
              <Col className='px-3' xs={12} sm={6}>

                <p style={{ textAlign: 'justify' }}> Centre for Distance and Online Education, GJUS&T Hisar, in collaboration with HKCL, started 17 online job-ready certificate courses designed to develop learners to take up specific industry roles in various sectors of the economy. After successful completion of these courses, learners will gain the skill knowledge and shall be able to start working either as entrepreneurs or apply for positions in different organizations where there is a requirement for the related posts as per the courses. These courses are structured to provide both theoretical knowledge and practical skills, ensuring that graduates are well-prepared for the demands of the job market. Additionally, continuous support and resources are offered to help learners transition smoothly into their chosen career paths.
                </p>
              </Col>

              <Col xs={12} md={6} className='border' style={{
                boxShadow:
                  "0 3px 7px 0 rgba(0, 0, 0, 0.2), 0 4px 16px 0 rgba(0, 0, 0, 0.19)",
                borderRadius: "5px"
              }} >

                <h3 className='text-center blinking-text' style={{ color: 'red' }}> <strong>What's New</strong></h3>
                <ul >
                  {/* {notices?.map((notice)=>{
              <li><a href="" rel="noreferrer" onClick={download(notice.key)}> {notice.title}</a>
              </li>
             })} */}

                  <li><a href={link6} target="_blank" rel="noreferrer">Prospectus CDOE-HKCL July 2025</a>
                  </li>

                  {/* <li><a href={link5} target="_blank" rel="noreferrer">Notice for January 2025  Admissions</a>
                  </li> */}
                  <li><a href={link1} target="_blank" rel="noreferrer"> Detailed Brochure - Online Certificate Courses</a>
                  </li>
                  <li>
                    <a href={link2} target="_blank" rel="noreferrer"> Brief Brochure - Online Certificate Courses </a>
                  </li>
                  <li>
                    <a href={link3} target="_blank" rel="noreferrer"> Revised Prospectus(CDOE) 2024-25  </a>
                  </li>

                  <li>
                    <a href={AdmissionJuly} target="_blank" rel="noreferrer"> Admission Brochure July 2025 </a>
                  </li>
                  <li>
                    <a href={Pjuly} target="_blank" rel="noreferrer"> Prospectus CDOE HKCL July 2025  </a>
                  </li>
                </ul>
              </Col>

            </Row>


            {/* <div className="info-header mt-4">
          <h5 ><strong>Objective of these courses</strong></h5>
        </div>
        <div >
          <p style={{textAlign:'justify' }}>
          These certificate courses are basic and advanced level courses aligned with National Skill Quality Framework (NSQF), which will enable a person to acquire desired competency levels, transition to the job market, and at an opportune time, return to acquire additional skills to upgrade their competencies further </p>
        
          <p style={{textAlign:'justify' }}> 
          The focus of these courses is on knowledge-based skills for career development in diverse areas. These e-courses are designed to respond to emerging technologies, markets, job roles, and international certification standards. They attempt to imbibe job-role readiness, desired social behaviour, self-confidence, and growth mindset necessary for college learners to effectively enter the 21st-century workspace either as employees or as entrepreneurs.</p>
        
        </div> */}



            <div className='mt-4'>
              <Row>
                <Col className='px-3' xs={12} sm={6}>

                  <div class="card card-info">
                    <div class="card-header">
                      <h3 class="card-title text-bold">From the Director’s Desk</h3>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-4">
                          <img width={"100%"} src={director} alt='PhotoError' className='px-3 mt-2 ' />
                        </div>
                        <div class="col-md-8" style={{ textAlign: 'justify' }}>
                          <p>
                            It gives me immense pleasure to welcome you to the online portal of the Centre for Distance and Online Education, Guru Jambheshwar University of Science and Technology, Hisar. Established in the year 1997, the Centre aims to meet the demand for job-oriented programs. We have recently launched 17 job ready online certificate courses in collaboration with HKCL -
                          </p>
                        </div>

                        <div style={{ textAlign: 'justify' }}>
                          <p> Haryana Knowledge Corporation Limited, a state government-promoted organization.
                          </p>
                        </div>

                        <div style={{ textAlign: 'justify' }}>
                          <p>
                            These online courses focus on knowledge-based skills for career development in diverse areas. They are designed to respond to emerging technologies, markets, job roles, and international certification standards. Our courses aim to instill job readiness, desired social behaviors, self-confidence, and a growth mindset necessary for learners to effectively enter the 21st-century workforce, whether as employees or entrepreneurs.</p>
                          <p> Furthermore, these courses provide a unique opportunity to enhance your skills through a flexible and convenient online learning platform. From these courses, you can gain practical knowledge and hands-on experience that will empower you to excel in your chosen field. </p><p>
                            On behalf of the Centre for Distance and Online Education, I congratulate the students who have opted to join these online certificate courses. I am confident that students enrolling in these courses will greatly benefit from the ever-growing job market in India and abroad, as they are designed to prepare learners for specific industry roles in various sectors of the economy.</p>
                          <div style={{ float: 'right' }} >
                            <h5 style={{ color: '#ff0000' }}><strong>Prof. Khujan Singh </strong></h5>
                            <h6 style={{ float: 'right', color: '#0d0dc5' }}><strong>Director </strong></h6>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col className='px-3' xs={12} sm={6}>
                  <div class="card card-info">
                    <div class="card-header">
                      <h3 class="card-title text-bold">Online Admission Process</h3>
                    </div>


                    <div class="timeline mt-2">
                      <div>
                        <i class="fa fa-user-plus bg-blue"></i>
                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header"><a target="_blank">Step 1 - Online Registration</a> </h3>
                          <div class="timeline-body">
                            OTP based Registration
                          </div>
                        </div>
                      </div>


                      <div>
                        <i class="fa fa-list bg-yellow"></i>

                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header no-border"><a >Step 2 - Admission Form</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Filling up of Admission form and upload documents.</li>
                            </ul>
                          </div>
                        </div>
                      </div>


                      <div>
                        <i class="fas fa-check bg-red"></i>

                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header"><a >Step 3 – Fee Payment</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Payment of Registration Fee of Rs. 100/-.</li>
                            </ul>
                          </div>
                        </div>
                      </div>


                      <div>
                        <i class="fas fa-list-ol bg-pink"></i>
                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-warning">University</span></span>
                          <h3 class="timeline-header"><a >Step 4 – Document Verification</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Uploaded documents will be reviewed, and candidates will receive an ‘Approval’ or ‘Rejection’ message.</li>

                            </ul>
                          </div>
                        </div>
                      </div>

                      <div>
                        <i class="fas fa-rupee-sign bg-purple"></i>
                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header"><a >Step 5 – Full Course Fee Payment</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Candidates receive a payment link in login for full course fee payment.</li>
                            </ul>
                          </div>
                        </div>
                      </div>



                      <div>
                        <i class="fas fa-user-check bg-orange"></i>
                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header"><a >Step 6 – Access to Learning Management System</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Candidates receive an email with guidelines to access the LMS within 3-4 working days.</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div>
                        <i class="fas fa-user-check bg-green"></i>
                        <div class="timeline-item">
                          <span class="time"><i class="fas fa-clock"></i><span class="badge badge-info">Candidate</span></span>
                          <h3 class="timeline-header"><a >Step 7 – Student Support</a></h3>
                          <div class="timeline-body">
                            <ul>
                              <li>Dedicated team members are available to support learners throughout their course journey.</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </Col>
              </Row>

            </div>
            <div className='mt-3'>
              <img width={"100%"} src={imageGreen} alt='img' />
            </div>
          </CardBody>
        </Card>



      </div>

    </>
  )
};

Home.propTypes = {};

Home.defaultProps = {};

export default Home;
